import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { locales, setupI18n } from 'plottr_locales'

import { localeSettings } from '../lib/locale-settings'

import '../styles/globals.scss'
import '../styles/account.scss'

/**
 * @typedef {import('plottr_locales').Locale} Locale
 */

/**
 * @type {'en'}
 */
const EN_LOCALE = 'en'

/**
 * @type {Array<Locale>}
 */
// NOTE(ed): the type is literally constructed from the keys of the
// object called `locales`.  I suppose TS isn't happy with this
// because you *could* dynamically extend that object :/
//
// @ts-ignore
const LOCALES = [...Object.keys(locales)]

/**
 * @return {Locale}
 */
const getLocaleFromNavigator = () => {
  const navigatorLocaleString = navigator.language
  const candidateLocaleString = navigatorLocaleString.includes('-')
    ? navigatorLocaleString.substring(0, navigatorLocaleString.indexOf('-'))
    : navigatorLocaleString
  return LOCALES.reduce((acc, next) => {
    if (next === candidateLocaleString) {
      return next
    } else {
      return acc
    }
  }, EN_LOCALE)
}

const Plottr = ({ Component, pageProps }) => {
  useEffect(() => {
    const { seedTemplates } = require('../lib/templates')
    seedTemplates()

    setupI18n(localeSettings, { locale: getLocaleFromNavigator() })
  }, [])

  return <Component {...pageProps} />
}

Plottr.propTypes = {
  Component: PropTypes.func.isRequired,
  pageProps: PropTypes.object,
}

export default Plottr
